import { createContext, useContext } from "react";
const FormValuesContext = createContext(
  void 0
);
function useFormValues() {
  const context = useContext(FormValuesContext);
  if (context === void 0) {
    throw new Error("useFormValues must be used within a FormValuesProvider");
  }
  return context;
}
export {
  FormValuesContext,
  useFormValues
};
//# sourceMappingURL=form-values-context.js.map
